import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Address } from './address';
import { Site } from './site';
import { SiteGroup } from './site-group';

export class AddressGroup extends BaseClass implements BaseRepository {
  name: string;
  addressIds: string[];
  siteIds: string[];
  siteGroupIds: string[];
  addresses: Address[];
  sites: Site[];
  siteGroups: SiteGroup[];

  constructor()
  constructor(
    name: string,
    addressIds: string[],
    siteIds: string[],
    siteGroupIds: string[],
  )
  constructor(
    name?: string,
    addressIds?: string[],
    siteIds?: string[],
    siteGroupIds?: string[],
  ) {
    super();

    this.name = this.trim(name);
    this.addressIds = addressIds || [];
    this.siteIds = siteIds || [];
    this.siteGroupIds = siteGroupIds || [];
    this.addresses = [];
    this.sites = [];
    this.siteGroups = [];
  }

  static fromObject(object: AddressGroup): AddressGroup {
    return Object.assign(new AddressGroup(), {
      ...object,
      addressIds: object.addressIds || [],
      siteIds: object.siteIds || [],
      siteGroupIds: object.siteGroupIds || [],
      addresses: object.addresses
        ? object.addresses.map((address) => Address.fromObject(address))
        : [],
      sites: object.sites ? object.sites.map((site) => Site.fromObject(site)) : [],
      siteGroups: object.siteGroups
        ? object.siteGroups.map((siteGroup) => SiteGroup.fromObject(siteGroup))
        : [],
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }
}
